<div class="w-full text-center mb-4">
	<p class="text-2xl font-bold">Complete form</p>
	<p class="mt-2 text-base text-gray-600">
		Please select an order form and fill in the required information.
	</p>
</div>

<div
	class="flex gap-5 rounded-xl border-grey bg-grey-veryLight p-20 my-5 item-center justify-center"
>
	<div
		[ngClass]="{
			'border border-blue-500 bg-blue-100':
				(selectedForm$ | async) === under25Url.value,
			'bg-white': (selectedForm$ | async) !== under25Url.value,
		}"
		class="rounded-lg shadow-md px-8 py-4 w-fit space-y-4 cursor-pointer hover:bg-blue-100"
		(click)="openModal('under')"
		[testHook]="testHooks.OpenModalDiv"
	>
		<p class="text-center font-bold">Value under $25M</p>
		<div class="h-32 w-32">
			<img src="/assets/images/integrations/forms/fct-under-25.svg" />
		</div>
	</div>
	<div
		[ngClass]="{
			'border border-blue-500 bg-blue-100':
				(selectedForm$ | async) === over25Url.value,
			'bg-white': (selectedForm$ | async) !== over25Url.value,
		}"
		class="rounded-lg shadow-md px-8 py-4 w-fit space-y-4 cursor-pointer hover:bg-blue-100"
		(click)="openModal('over')"
		[testHook]="testHooks.OpenModalDiv1"
	>
		<p class="text-center font-bold">Value over $25M</p>
		<div class="h-32 w-32">
			<img src="/assets/images/integrations/forms/fct-over-25.svg" />
		</div>
	</div>
</div>
